import { inject, Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '@core/services/loader.service';

export const X_SKIP_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests = new Set<HttpRequest<unknown>>();
  loaderService = inject(LoaderService);

  removeRequest(req: HttpRequest<unknown>) {
    this.requests.delete(req);
    this.loaderService.isLoading.set(this.requests.size > 0);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipLoader = req.headers.get('X-Skip-Loader');
    if (skipLoader || req.context.get(X_SKIP_LOADER)) {
      return next.handle(req);
    }

    this.requests.add(req);
    this.loaderService.isLoading.set(true);

    return next.handle(req).pipe(finalize(() => this.removeRequest(req)));
  }
}
